export const userTokenStorageKey = 'APP_USER_TOKEN'
